import { observer } from 'mobx-react-lite';
import PageSettings from './PageSettings';
import type { PageSettingsProps, PageSettingsValueProps } from './types';

export type { PageSettingsProps, PageSettingsValueProps };
export default observer(PageSettings); // MANUAL OVERRIDE
